// COULD BE IMPORTED TO CLIENT AND SERVER CODE

export function formatDate(dateCreated: string) {
  const date = new Date(dateCreated);
  const month = date.toLocaleString('default', { month: 'short' });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day}, ${year}`;
}

export function getFeaturedImageSmall(url?: string) {
  return url ? `${url}?fit=fill&w=286&h=160` : undefined;
}

// 5 minutes
export const DEFAULT_BLOG_REVALIDATE_PERIOD = 5 * 60;
